import { ApolloError, gql as GraphQL, useQuery } from "@apollo/client";

export interface DataType {
    profile: IProfile;
    guilds: { id: Snowflake; name: string; icon: string; owner: boolean; commands: number; modules: number; hasClient: boolean }[];
}

const QueryGraphQL = GraphQL`
    query getServerPageQuery {
        getProfile {
            _id
            settings {
                user {
                    username
                    discriminator
                    avatar
                }
            }
        }

        getGuild(guildReturn: "@mutual") {
            mutual {
                id
                name
                icon
                owner
                commands
                modules
                hasClient
            }
        }
    }
`;

const Query = (): { loading: boolean; error: ApolloError | undefined; data: DataType | null; refetch: Function } => {
    const { loading, error, data, refetch } = useQuery(QueryGraphQL);

    if (error) console.log(error);

    if (loading || error) return { loading: true, error, data: null, refetch };

    return { loading: false, error, data: { profile: data.getProfile, guilds: data.getGuild.mutual }, refetch };
};

const Hook = { Query };

export default Hook;
